import './styles/policies.scss';

import Layout from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Layout/Layout';
import React from 'react';
import ReactMarkdown from 'react-markdown';
import SEO from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Seo';
import { TitleBanner } from '../components/Primitives';
import { graphql } from 'gatsby';
import useMobileDetect from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Hooks/useMobileDetect';
import { usePageLocalization } from '@sbi-international/boutik.gatsby.plugin.multilocale';

export const query = graphql`
    query {
        returnPolicy: allProductsJson(
            filter: { code: { eq: "drolet_return-policy" } }
        ) {
            nodes {
                code
                title {
                    en_CA
                    en_US
                    fr_CA
                }
                fields {
                    banniere_desktop {
                        childImageSharp {
                            gatsbyImageData(layout: CONSTRAINED)
                        }
                    }
                    banniere_mobile {
                        childImageSharp {
                            gatsbyImageData(layout: CONSTRAINED)
                        }
                    }
                }
                attributes {
                    content {
                        values {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                    meta_title {
                        values {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                    meta_description {
                        values {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                }
            }
        }
    }
`;
export default function ReturnPolicy({ data }) {
    const { currentLocale } = usePageLocalization();
    const metadataAttributes = data?.returnPolicy?.nodes[0]?.attributes;
    const returnPolicyContent =
        metadataAttributes?.content?.values[0][currentLocale];
    const metadata = {
        title: metadataAttributes?.meta_title?.values[0][currentLocale],
        description:
            metadataAttributes?.meta_description?.values[0][currentLocale],
    };
    const pageTitle = data?.returnPolicy?.nodes?.[0]?.title?.[currentLocale];
    const isMobile = useMobileDetect().isMobile();
    const responsiveImages = data?.returnPolicy?.nodes?.[0]?.fields;
    const desktopImage =
        responsiveImages?.banniere_desktop[0]?.childImageSharp
            ?.gatsbyImageData;
    const mobileImage =
        responsiveImages?.banniere_mobile[0]?.childImageSharp
            ?.gatsbyImageData;

    return (
        <div>
            <Layout>
                <SEO
                    title={metadata?.title}
                    description={metadata?.description}
                />
                <TitleBanner
                    imageData={isMobile ? mobileImage : desktopImage}
                    title={pageTitle}
                />
                <div className='container policy-class'>
                    <ReactMarkdown>{returnPolicyContent}</ReactMarkdown>
                </div>
            </Layout>
        </div>
    );
}
